import { Component, Input } from '@angular/core';
import { AbstractDataProvider } from 'src/app/AbstractDataProvider';
import { DataItemModel } from '../../../../shared/model/interfaces';
import { DictionaryPipe } from '../../../../shared/pipes/dictionary.pipe';
import {getErrorMessageText} from '../../../helper';


@Component({
  selector: 'app-forms-block',
  templateUrl: './forms-block.component.html',
  styleUrls: ['./forms-block.component.scss'],
  providers: [DictionaryPipe]
})
export class FormsBlockComponent  {

  @Input() forms: DataItemModel[] = [];
  @Input() label = '';
  @Input() differentLoggedIn: boolean;

  display = false;
  alertMessage: string;
  InboxCount = 0;
  TotalActiveCommitmentAmt = 0;
  TotalActiveCapitaltAmt = 0;
  TotalActiveUnits = 0;
  TotalActiveValueAmt = 0;

  downloadDocumentImagUrl: string = this.abstractDataProvider.baseUrl + 'api/File/FileDownloadFromDocumentImage?SeqNum=';

  constructor(private abstractDataProvider: AbstractDataProvider,
              private dictionaryPipe: DictionaryPipe) {
  }


  Download(DocSeqNum: number, FileNum: number) {
    this.abstractDataProvider.getData('api/File/IsFileExist?SeqNum=' + DocSeqNum + '&forWhat=form')
      .subscribe(
        posts => {
          if (posts.Message) {
            this.display = true;
            this.alertMessage = posts.Message;
          } else if (posts.DocSeqNum) {

            const fileUrl = this.downloadDocumentImagUrl + posts.DocSeqNum + '&forWhat=form&CurrentUserNumber=' + posts.CurrentUserNumber + '&FileNum=' + FileNum
            this.abstractDataProvider.downloadFile(fileUrl)
              .subscribe(_ => {}, error => {
                this.display = true;
                this.alertMessage =  getErrorMessageText(error);
              });

            // window.open(this.downloadDocumentImagUrl + posts.DocSeqNum + '&forWhat=form&CurrentUserNumber=' + posts.CurrentUserNumber + '&FileNum=' + FileNum, '_blank');
          } else {
            this.display = true;
            this.alertMessage = this.dictionaryPipe.transform('FILE_NOT_FOUND');
          }
        },
        error => {
          this.display = true;
          this.alertMessage =  getErrorMessageText(error);
        }
      );
  }

  onConfirm() {
    this.display = false;
  }


}
